import { useState } from "react";
import { Textareawithsteroids, Textareawithsteroids2 } from "../ESG/EnvironmentReport";
import { HeaderShow } from "../ESG/ESGmain";

const Step3 = () => {
    const [showContent,setShowContent] = useState(false)
    const subtext = `Now combine the subgoals with your value chain activities - do they touch upon eachother somewhere ? Do you have the chance to support creatinon of a school and supply money for teaching in one of the farms or plants your source from, so the children of the farmers gets education when the parents work in a farm that delivers to you? Can you support they get free access to healthcare?
    
While all the goals are important here are some tips for specific look out

Typically if you are a:

SME sized company
Pay attention to the subgoals for 5,7,8 and 12.

Government, municipality or other public organization
Pay extra attention to 9,11 and 13

Large international org. or NGO
Subgoals for SDG 17 are of extra importance.

Sector dependent
Subgoals are 3,4,6,10 and 16, investigate these further with you sector perspective on.

Usually it is not recommended to work with more than 3-4 goals at a max, as it takes quite a lot of effort, measurement and time. Rather do one with greate impact, than four for show.`

    const actiontext = `Based upon your knowledge and research, narrow down the field to the SDGs of relevance. The goal is to see where there are synergies and interactions that means you can really make an imppact or really get troubled waters for your company, if this subject is not handled.`
    const exercisetext = `Make a mini "Summit" in your company to get everyone involved and engaged in the process - what department runs with what, who are the projectmanagers and what are we passionate about doing?`
    return ( 
        <div className="d-flex flex-column align-items-center mt-2">
        <HeaderShow text={"Step 3 Explore"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
        
        {
            showContent ?
            <>
            <div className="roleambition__bubble w-90 mt-3 ms-0">
                <h5>{subtext}</h5>
                <div className="d-flex justify-content-between mt-2">
                    <div className="d-flex flex-column me-5">
                        <h5 style={{textAlign:"center"}}><b>Action</b></h5>
                        <h5>{actiontext}</h5>
                    </div>
                    <div className="d-flex flex-column">
                        <h5 style={{textAlign:"center"}}><b>Exercise</b></h5>
                        <h5>{exercisetext}</h5>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-around w-90">
                <div className="sdg__action__exercise">
                    <h4>Action:</h4><Textareawithsteroids2   
                        maxLength={3000}
                        keyHighlight={"step3_action"}
                    />        
                </div>
                <div className="sdg__action__exercise">
                    <h4>Exercise:</h4><Textareawithsteroids2   
                        maxLength={3000}
                        keyHighlight={"step3_exercise"}
                    />        
                </div>
            </div>
            <div className="sdg__action__exercise w-85">
                <h4>Write in your conclusions here:</h4><Textareawithsteroids2   
                    maxLength={3000}
                    keyHighlight={"step3_conclusion"}
                />        
            </div>
            </>:null
        }
        
        </div>
     );
}
 
export default Step3;